/* eslint-disable semi */
import React from 'react'
import { TextField, TextFieldProps } from './TextField'
import { formatDigits } from '../Utility'

export function isAbnFormatValid(value: string) {
  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19]
  const abn = value.replace(/[^\d]/g, '')
  let result = false

  if (abn.length === 11) {
    let sum = 0
    let weight

    for (let index = 0; index <= weights.length - 1; index++) {
      weight = weights[index]
      const digit = (abn[index] as any) - (index ? 0 : 1)
      sum += weight * digit
    }

    result = sum % 89 === 0
  }

  return result
}

export interface AbnFieldProps extends TextFieldProps {
   onLostFocus?: (value: string, isValid: boolean) => void;
}
export class AbnField extends TextField<AbnFieldProps> {
  constructor(props) {
    super(props);
    this.onBlurHandler = this.onBlurHandler.bind(this);
  }

  onBlurHandler(v: string) {
    if (!v) return;

    const formattedValue = formatDigits(v);
    const isValid = isAbnFormatValid(formattedValue);

    if (!isValid) {
      this.setError('ABN invalid');
    }

    super.onBlurHandler(formattedValue); // Call base to handle state update

    // Trigger external handler with ABN and its validity status
    if (this.props.onLostFocus) {
      this.props.onLostFocus(formattedValue, isValid);
    }
  }

  getErrorText(): string {
    const error = super.getErrorText();
    if (error) {
      return error;
    }

    if (this.hasValue()) {
      if (!isAbnFormatValid(this.getValue())) {
        return 'ABN invalid';
      }
    }

    return null;
  }

  render() {
    return (
      super.render()
    );
  }
}
